export const CHECK_HOLIDAY = "CHECK_HOLIDAY";
export const CHECK_HOLIDAY_START_LOADER = "CHECK_HOLIDAY_START_LOADER";
export const CHECK_HOLIDAY_STOP_LOADER = "CHECK_HOLIDAY_STOP_LOADER";
